import './active-claims-modal.scss';

import { Box } from '@mui/material';
import { FormCheckBoxField } from '../../../../presentation/components';
import { WarningConfirmationProps } from './active-claims-modal';

export const InactiveReinstatementConfirmation = ({
  isChecked,
  setIsChecked,
  setIsDisabled,
}: WarningConfirmationProps) => {
  return (
    <>
      <Box className="context">
        This policy has been inactive for 90 days or more. Please review this
        reinstatement with the
        <strong className={'bold-text'}> Underwriting Manager</strong> before
        proceeding.
      </Box>
      <FormCheckBoxField
        name=""
        label="I have reviewed reinstating this policy with the Underwriting Manager"
        customWeight="400"
        customFont="16px"
        size="medium"
        checked={isChecked}
        handleChange={(e) => {
          setIsChecked(e.target.checked);
          setIsDisabled(!e.target.checked);
        }}
      />
    </>
  );
};
